import { useCategoriesListQuery, UseCategoriesListQueryParams } from '../queries';
import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { FormState } from 'react-hook-form';
import { Input } from '~/components/Input';

interface Props<TFormState extends BaseFormState> {
  onChange?: (values: number[]) => void;
  query?: UseCategoriesListQueryParams;
  formState?: FormState<TFormState>;
  disabled?: boolean;
  value?: number[];
}

function CategoryMultiSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data = [], isLoading } = useCategoriesListQuery(props.query);

  return (
    <Input.MultiSelect
      options={data.map(o => [o.label, o.id])}
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      disabled={props.disabled || isLoading}
      placeholder="Välj ålderskategorier"
      ref={ref}
      {...props}
    />
  );
}

export const CategoryMultiSelect = forwardRef(CategoryMultiSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof CategoryMultiSelectElement>;
